import { useState } from 'react';

const usePopup = () => {
    const [isShow, setIsShowing] = useState(false);

    function popupAction() {
        //팝업 생성 시 body의 scroll 작동이 되지 않도록(default값: GlobalStyle)
        document.body.style.overflowY = isShow ? "auto" : "hidden"
        setIsShowing(!isShow);
    }

    return {
        isShow,
        popupAction,
    }
};

export default usePopup;